import { CE10_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/CE10/plasmic-props";
import { CE11_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/CE11/plasmic-props";
import { CE13_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/CE13/plasmic-props";

import {
  CATALOG_ENTRIES_VARIANTS,
  CE_11 as CATALOG_ENTRIES_CE11,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const STATIC_CATALOG_ENTRIES_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: CATALOG_ENTRIES_VARIANTS,
    defaultValue: CATALOG_ENTRIES_CE11,
    description: "Select catalog entries variant",
  },
  ...CE10_PLASMIC_PROPS,
  ...CE11_PLASMIC_PROPS,
  ...CE13_PLASMIC_PROPS,
  className: {
    type: "string",
    defaultValue: "",
  },
};
